import { SituationKey } from '../constant/SituationKey';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class Situation extends BaseEntityModel {
  id?: number;
  modelType?: string;
  modelId?: number;
  situations?: SituationKey[];

  constructor(model: Partial<Situation> = {}) {
    super(model);

    this.id = model.id;
    this.modelId = model.modelId;
    this.modelType = model.modelType;
    this.situations = model.situations;
  }
}
